module.exports = __webpack_public_path__ + "img/recover.aeed62e9.svg";